import React from 'react';
import { Form } from '@crisellevaldez/speculo-ui';
import { SearchableSelect } from '../../../common/SearchableSelect';
import { useCitySearch } from '../../../../hooks/cities/useCitiesData';

interface CitySelectorProps {
  organizationId: string;
  selectedCities: string[];
  onChange: (cityIds: string[]) => void;
  error?: string;
  onLoadingChange?: (isLoading: boolean) => void;
}

export const CitySelector: React.FC<CitySelectorProps> = ({
  selectedCities,
  onChange,
  error,
  onLoadingChange,
}) => {
  const { cities, isLoading, hasMore, loadMore, setSearch } = useCitySearch();

  // Handle loading state changes
  React.useEffect(() => {
    onLoadingChange?.(isLoading);
  }, [isLoading, onLoadingChange]);

  const options = React.useMemo(
    () =>
      cities.map((city) => ({
        value: city.id,
        label: `${city.name}, ${city.state}`,
      })),
    [cities]
  );

  return (
    <Form.Control>
      <Form.Label>Subscribe Cities</Form.Label>
      <Form.HelperText>Select cities to enable on your website</Form.HelperText>
      <SearchableSelect
        multiple
        options={options}
        value={selectedCities}
        onChange={onChange}
        isLoading={isLoading}
        hasMore={hasMore}
        onLoadMore={loadMore}
        onSearch={setSearch}
        placeholder="Select cities"
        searchPlaceholder="Search cities..."
        error={error}
        className="w-full"
      />
    </Form.Control>
  );
};
